var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRitualsBgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3268_27130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 164,
    height: 164
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 32C0.5 16.9151 0.5 9.37258 5.18629 4.68629C9.87258 0 17.4151 0 32.5 0H132C147.085 0 154.627 0 159.314 4.68629C164 9.37258 164 16.9151 164 32V131.5C164 146.585 164 154.127 159.314 158.814C154.627 163.5 147.085 163.5 132 163.5H32.5C17.4151 163.5 9.87258 163.5 5.18629 158.814C0.5 154.127 0.5 146.585 0.5 131.5V32Z",
    fill: "#4A56DB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3268_27130)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 82,
    cy: 138,
    r: 106,
    fill: "#6167E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_d_3268_27130)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 82.0007,
    cy: 138,
    r: 69.0359,
    fill: "#888BEB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3268_27130",
    x: 8.96484,
    y: 68.9639,
    width: 146.072,
    height: 146.072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3268_27130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3268_27130",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitualsBgDefault);
export default __webpack_public_path__ + "static/media/ritualsBgDefault.6a840c8215706791a06fd726dd09a32d.svg";
export { ForwardRef as ReactComponent };